<ng-container [formGroup]="changeOrder">
  <div class="card-body">
    <h2>Add Change Order </h2>
    <div class="form-row" >
      <div class="form-group col-12">
         <label for="job_search-field-scrollable" class="custom_label"> Job *</label>
        <app-scrollable-search-field
          id="job_search-field-scrollable"
          [dataService]="JobDataService"
          [dataServiceFunctionName]="'search'"
          [sortBy]="'id'"
          [sortOrder]="'desc'"
          [searchPlaceHolder]="'Select job'"
          [labelKey]="'job_name'"
          [formDataMapper]="{'id': 'id', 'name' : 'job_name'}"
          [keyNameToShowWhenSelected]="'name'"
          [inputVal]=" ''"
          (selectedValueChange)="selectedJobValueChange($event)"
          [markCtrlTouched]="changeOrder.get('job_id')?.touched"
        >
        </app-scrollable-search-field>
<!--        <app-validation-error [formGroup]="changeOrder" [controlName]="'job_id'"></app-validation-error>-->
      </div>
      <div class="form-group col-12">
        <label class="custom_label">Change Order Type *</label>
        <ng-select
          id="orderType"
          [items]="orderTypeList"
          placeholder="Order Type"
          [closeOnSelect]="true"
          formControlName="orderType"
          bindLabel="name"

        >
        </ng-select>
        <app-validation-error [formGroup]="changeOrder" [controlName]="'orderType'"></app-validation-error>
      </div>
    </div>
  </div>
</ng-container>
